/**
 * 侧栏 menuId 分区 SSOT
 *
 * 规则（根治 menu 树漂移 · 2026-07-15）：
 * 1. Leo 二级文件夹（LEO_SIDEBAR_FOLDER_IDS）已入库 coffee_menu（patch 133）；
 *    侧栏与角色授权树只跟 parent_id，**禁止**常态 strip + buildLeoKnowledgeSidebarTree 重建。
 * 2. SYSTEM_SETTINGS_PLATFORM_MENU_IDS — 挂在 systemSetting 下，跟 nav API 树。
 * 3. buildLeoSidebarStripIdSet / 静态 rebuild 仅作「DB 尚未跑 133」时的临时兜底。
 *
 * @see scripts/mysql/menu_tree_ssot/leo_knowledge_folders.json（Overseas）
 * @see .cursor/rules/sidebar-content-ssot.mdc
 */

/** Leo 侧栏二级分组（patch 133 起入库，非虚拟） */
export const LEO_SIDEBAR_FOLDER_IDS = {
  portalOverview: 990276,
  modelKnowledge: 990277,
  ingestLoop: 990278,
  protocolTools: 990279,
  opsWorkbench: 990284,
  deviceIntel: 991009
}

/** systemSetting 下平台超管页（patch 077 / 092）；侧栏位置由 coffee_menu parent 决定 */
export const SYSTEM_SETTINGS_PLATFORM_MENU_IDS = {
  uiSurfaceSample: 990263,
  aiTrusteeAdmin: 990271,
  agentPermissionSteward: 990272,
  platformReleaseControl: 990340
}

/** 设备研发一级及其子项（patch 128；parent 对齐 scripts/mysql/menu_tree_ssot/device_rd_group.json） */
export const DEVICE_RD_SIDEBAR_MENU_IDS = {
  group: 990130,
  machineDebug: 990220,
  simulatorGroup: 990105,
  /** coffee_menu 历史 id（非 990100） */
  deviceConfigGroup: 1721413909652439040,
  deviceLinkDebug: 990346,
  equipmentModelRepair: 990326
}

/** 库存管理（patch 115–123；990390 组，勿与 990380 售后冲突） */
export const STORE_MATERIAL_SIDEBAR_MENU_IDS = {
  group: 990390,
  stock: 990391,
  orders: 990392,
  consumable: 990393,
  mq: 990394,
  invoice: 990395,
  barcodeAlias: 990396,
  count: 990397,
  bomWizard: 990398,
  analytics: 990399,
  physicalMerge: 990400
}

/** 数据中心 · 泡茶机数据 · 泡茶机物料（patch 152；设备自动化物料，勿挂 990390） */
export const TEA_MACHINE_MATERIAL_SIDEBAR_MENU_IDS = {
  page: 990412
}

/** 数据中心 · 泡茶机数据 · 单杯参数（patch 157；品质分析，不影响原单杯数据） */
export const TEA_SINGLE_CUP_PARAMS_SIDEBAR_MENU_IDS = {
  page: 990413
}

/** 出品 · X600H 配方中心（patch 124/125）；侧栏仅认 role_menu，禁止 device:edit 硬注入 */
export const X600H_RECIPE_CENTER_MENU_IDS = {
  coffeeMachineChannelSlots: 990401
}

/**
 * buildLeoKnowledgeSidebarTree / buildTrainingLakeSidebarTree 会静态回填的 menuId。
 * 新增 Leo 侧栏叶节点：先加此处 + builder，再加路由。
 */
export const LEO_SIDEBAR_REBUILD_MENU_IDS = {
  group: 990200,
  modelFields: 990241,
  upload: 990242,
  onboarding: 990243,
  capabilityMatrix: 990244,
  pipelineHub: 990245,
  featureSurface: 990246,
  protocolDoc: 990247,
  remoteTool: 990248,
  learning: 990249,
  externalIngest: 990250,
  ingestBatch: 990251,
  phase1Ssot: 990252,
  equipmentTypeTypeKey: 990253,
  testerConsole: 990254,
  deviceOpsRolePolicy: 990255,
  deviceOpsSemanticTraining: 990256,
  productionE2eTraining: 990266,
  turnRoutingTraining: 990267,
  trainingDashboard: 990268,
  t2GoldenTraining: 990269,
  t9DeepseekTraining: 990270,
  portalHub: 990257,
  portalOpsInventoryConsole: 990258,
  portalOpsDailyHub: 990259,
  deviceOpsReviewInbox: 990260,
  deviceOpsDescriptionAutogen: 990261,
  deviceOpsBLineDailyHub: 990262,
  commandOnboardingWizard: 990264,
  xeeGrowthDashboard: 990265,
  trainingFederationCases: 991001,
  trainingFederationCommandCenter: 991002,
  tasteHabitPerception: 991003,
  trainingDecisionDesk: 991004,
  t7TasteMl: 991005,
  intelligenceGrowthDashboard: 991007,
  deviceOpsBundleCandidates: 991008,
  clawPlanCapabilityHub: 991006,
  e1Overview: 991010,
  e1Components: 991011,
  e1Proposals: 991012,
  e1Production: 991015,
  e1Health: 991016,
  e1Impact: 991017,
  e1Policy: 991018,
  e1TargetQuality: 991019,
  e1Curves: 991020,
  e1Peer: 991021,
  e1LifeGate: 991022
}

/** @deprecated 已无「仅路由」Leo 页；保留空对象以免旧 import 崩 */
export const LEO_KNOWLEDGE_ROUTE_ONLY_MENU_IDS = {
}

/** 路由 meta.menuId 引用（Leo 域） */
export const LEO_KNOWLEDGE_MENU_IDS = Object.assign(
  {},
  LEO_SIDEBAR_REBUILD_MENU_IDS,
  LEO_KNOWLEDGE_ROUTE_ONLY_MENU_IDS
)

/** @returns {Set<number>} */
export function buildLeoSidebarStripIdSet () {
  const strip = new Set()
  Object.values(LEO_SIDEBAR_REBUILD_MENU_IDS).forEach((id) => {
    if (id != null) strip.add(Number(id))
  })
  Object.values(LEO_SIDEBAR_FOLDER_IDS).forEach((id) => {
    if (id != null) strip.add(Number(id))
  })
  Object.values(SYSTEM_SETTINGS_PLATFORM_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: SYSTEM_SETTINGS id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(DEVICE_RD_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: DEVICE_RD id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(STORE_MATERIAL_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: STORE_MATERIAL id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(TEA_SINGLE_CUP_PARAMS_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: TEA_SINGLE_CUP_PARAMS id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(TEA_MACHINE_MATERIAL_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: TEA_MACHINE_MATERIAL id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(LEO_KNOWLEDGE_ROUTE_ONLY_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: route-only id ${id} must not appear in Leo strip set until added to sidebar builder`
      )
    }
  })
  return strip
}

/** 单测：注册表分区互斥 */
export function assertSidebarMenuIdRegistry () {
  buildLeoSidebarStripIdSet()
  const sys = new Set(Object.values(SYSTEM_SETTINGS_PLATFORM_MENU_IDS).map(Number))
  const rebuild = new Set(Object.values(LEO_SIDEBAR_REBUILD_MENU_IDS).map(Number))
  for (const id of sys) {
    if (rebuild.has(id)) {
      throw new Error(`SYSTEM_SETTINGS id ${id} overlaps LEO_SIDEBAR_REBUILD_MENU_IDS`)
    }
  }
  return { strip: buildLeoSidebarStripIdSet(), systemSettings: sys, rebuild }
}



//////////////////
// WEBPACK FOOTER
// ./src/constants/sidebarMenuIdSsot.mjs
// module id = null
// module chunks = 